import classNames from 'classnames';
import { FC } from 'react';

export interface EmptyOrdersBasketProps {
  className?: string;
}
export const EmptyOrdersBasket: FC<EmptyOrdersBasketProps> = ({ className }) => {
  return (
    <div className={classNames(className, 'd-flex justify-content-center align-items-center h-100')}>
      <div className="d-flex flex-column align-items-center line-height-4 text-muted">
        <em className="icon icon-xl text-muted">playlist_add</em>
        <h3>Add quote to order basket</h3>
        <p className="mt-2 mb-5">Start adding or import quotes to the order basket for booking.</p>
      </div>
    </div>
  );
};
